import { Button, Form, InputCurrency } from "@sellar-io/components";
import { calculateTotal, formatCurrency } from "@sellar-io/common";
import { InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import { usePriceFormat } from "../../../../hooks/usePriceFormat";
import { useOrderOnBehalfOfContext } from "../OrderOnBehalfOf.shared";

export const CustomOrderDeliveryChargeDialog = ({
  active,
  onDismiss,
  onSubmit,
  onDelete,
}: {
  active: boolean;
  onDismiss: () => void;
  onSubmit?: (deliveryCharge: number) => void;
  onDelete?: () => void;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={"Add custom delivery charge"}
      />
      <DialogContent>
        <CustomOrderDeliveryChargeForm
          onDelete={onDelete}
          onSubmit={onSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

const CustomOrderDeliveryChargeForm = ({
  onDelete,
  onSubmit,
}: {
  onDelete?: () => void;
  onSubmit?: (deliveryCharge: number) => void;
}) => {
  const {
    calculatedDeliveryCharge,
    customDeliveryCharge: currentCustomDeliveryCharge,
    orderItems,
    customDiscount,
    customDiscountAmount,
    priceTierDiscountAmount,
    connection,
  } = useOrderOnBehalfOfContext();

  const customDeliveryChargePriceFormat = usePriceFormat(
    currentCustomDeliveryCharge ?? calculatedDeliveryCharge,
  );

  return (
    <Form
      className={"flex flex-col gap-4"}
      onSubmit={() => {
        if (customDeliveryChargePriceFormat.apiFormat === null)
          throw new Error("Value not defined");
        onSubmit?.(customDeliveryChargePriceFormat.apiFormat);
      }}
    >
      <div
        className={
          "flex items-center justify-between rounded-lg border border-solid px-4 py-2"
        }
      >
        <span>Delivery charge</span>
        <InputContainer>
          <InputCurrency
            showPrefix
            allowNegative
            min={0}
            required={true}
            value={customDeliveryChargePriceFormat.inputFormat}
            onChange={(e) =>
              customDeliveryChargePriceFormat.setInputFormat(e.target.value)
            }
          />
        </InputContainer>
      </div>
      <div>
        <div className={"flex justify-between px-4 text-gray-300 line-through"}>
          <span>Auto-calculated charges</span>
          <span>{formatCurrency(-calculatedDeliveryCharge)}</span>
        </div>
        <div className={"flex justify-between px-4"}>
          <span>Order total after discount (inc. VAT)</span>
          <span>
            {formatCurrency(
              calculateTotal({
                orderItems,
                deliveryCharge:
                  customDeliveryChargePriceFormat.apiFormat ??
                  calculatedDeliveryCharge,
                discountAmount:
                  customDiscount && typeof customDiscountAmount !== "undefined"
                    ? customDiscountAmount
                    : priceTierDiscountAmount,
                vatPercentage: connection.Supplier.vatPercentage,
              }),
            )}
          </span>
        </div>
      </div>
      <div className={"flex gap-2 *:flex-1"}>
        {currentCustomDeliveryCharge !== undefined ? (
          <Button color={"red"} onClick={() => onDelete?.()}>
            Remove
          </Button>
        ) : null}
        <Button type={"submit"}>Update</Button>
      </div>
    </Form>
  );
};
